import { render, staticRenderFns } from "./Pos_detail_product_data.vue?vue&type=template&id=2b7cc161&scoped=true&"
import script from "./Pos_detail_product_data.vue?vue&type=script&lang=js&"
export * from "./Pos_detail_product_data.vue?vue&type=script&lang=js&"
import style0 from "./Pos_detail_product_data.vue?vue&type=style&index=0&id=2b7cc161&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7cc161",
  null
  
)

export default component.exports